import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateInfodex} from '../containers/IsolatedInfodex/actions';
import {updateInfodexes} from '../containers/Infodex/actions';
const storageHandler = new StorageHandler();

function* getInfodex(action){
  const Network = new NetworkHandler();
  try{
    
    const response = yield Network.requestGetInfodex(action.payload);
  
    if (!(response instanceof Error)) {
        
        yield put(
              updateInfodex(
              response
            )
          );
		  
		  //localStorage.setItem("infodexData",JSON.stringify(response));
		  
      } else {
        yield put(
          error({
            message: 'Unable to load Linked Infodex',
          })
        );
    }
}catch (errorMsg) {
    yield put(
        error({
         message: `Unable to load Linked Infodex, please try again.${errorMsg}`,
        })
    );
}
}

function* getAllInfodexes(action){

  const Network = new NetworkHandler();
  
    try{
        const response = yield Network.requestGetAllInfodexes();
        
        if (!(response instanceof Error)) {
          yield put(
            updateInfodexes(
                response
              )
            );
			localStorage.setItem('allPlaces', JSON.stringify(response));
          } else {
            yield put(
              error({
                message: `Unable to get all infodex. ${response}`,
              })
            );
          }
  
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to load infodex groups, please try again.${errorMsg}`,
            })
        );
    }
}

export default function* usersSagas() {
  yield takeLatest(ACTIONS.CRYODEX_INFODEX_GET, getInfodex);
  yield takeLatest(ACTIONS.INFODEX_ALL_GET, getAllInfodexes);
}

